import {IEventProductData} from 'coreClasses/events/IEvents';
import ProductModel from 'coreClasses/product/ProductModel';
import ProductSearchHitModel from 'coreClasses/search/ProductSearchHitModel';
import {IProductPriceObject} from 'coreClasses/product/IProduct';
import {IBasketProductLineItem} from 'coreInterfaces/common/IBasket';
import {DATALAYER_CONFIGS} from 'brandConstants';

/**
 * Represents ECommerceProductModel
 */
export default class ECommerceProductModel {
	public id: string;
	public name: string;
	public price?: IProductPriceObject | number;
	public brand?: string;
	public category?: string;
	public variant?: string;
	public position?: number;
	public quantity?: number;

	/**
	 * @constructor
	 * @param {IEventProductData} productData - product data
	 */
	constructor(
		productData: IEventProductData,
		productItem?: IBasketProductLineItem
	) {
		const product: ProductModel = productData.product;
		const productHit: ProductSearchHitModel = productData.productHit;

		if (product?.isReady()) {
			const priceObject = product.getPriceModel().getMinPrice();
			const quantity = productItem?.quantity || 1;

			this.id = productData.variationGroupIdForCartEvents
				? product.getVariationGroupId()
				: product.getProductId();
			this.name = product.getName();
			this.price = DATALAYER_CONFIGS.showPriceValueOnly ? priceObject.value : priceObject;
			this.brand = product.getBrand();
			this.category = (productData as IEventProductData & {plpCategoryForProduct?: string}).plpCategoryForProduct
				? (productData as IEventProductData & {plpCategoryForProduct?: string}).plpCategoryForProduct
				: product.getPrimaryCategoryId();
			this.variant = product.getColorDescription();
			this.quantity = quantity;
		} else if (productHit) {
			this.id = productHit.getProductId();
			this.name = productHit.getName();
		}

		if (productData.position !== undefined) {
			this.position = productData.position;
		}
	}
}
